/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_TitleInputs */

const en_fc_home_hero_title = /** @type {(inputs: Fc_Home_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the FilmCraft video editor, learn the basics, start editing.`)
};

/**
* | output |
* | --- |
* | "Download the FilmCraft video editor, learn the basics, start editing." |
*
* @param {Fc_Home_Hero_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_title = /** @type {((inputs?: Fc_Home_Hero_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_title(inputs)
});
export { fc_home_hero_title as "fc.home.hero.title" }